import React from 'react';
// import { } from '@material-ui/core';
import { GitHub, Twitter, Copyright, LinkedIn } from '@material-ui/icons';
class Footer extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            linkedIn: 'https://www.linkedin.com/in/gideon-mwega-99292a168/',
            github: 'https://github.com/kompanycoder',
            twitter: 'https://twitter.com/Gmwega1'
        };
    }
    liveYear = ()=>{
        let date = new Date();
        let currentYear = date.getFullYear();
        return currentYear;

    };
    openLink = (e,link) => {
        // console.log(e, link);
        e.preventDefault();
        window.open(link);
    };
    render() {
        return (
            <div color="primary"  className="footer">
                <div className="social-icons">
                    <a className="github" onClick={(e) => this.openLink(e,this.state.github)}  href={`${this.state.github}`}><GitHub></GitHub></a>
                    <a className="twitter" onClick={(e) => this.openLink(e, this.state.twitter)} href={this.state.twitter}><Twitter></Twitter></a>
                    <a className="linkedIn" onClick={(e) => this.openLink(e, this.state.linkedIn)} href={this.state.linkedIn}><LinkedIn></LinkedIn></a>
                </div>
                
                <div className="copy-r">
                    <Copyright></Copyright><div> {this.liveYear()}.</div>
                </div>
            </div>
        )
    }
}

export default Footer;
